import React from "react";
import ReportCard from "../../components/ui/ReportCard";
import { ArrowUpIcon } from "@chakra-ui/icons";

export default function TotalDirectorates() {
  return (
    <ReportCard text={40} icon={<ArrowUpIcon />} title="Total Department" />
  );
}
